import {Item} from '@hconnect/common/Invite/Create/components/LookupDropdown'
import {ErrorPaper, SelectDropdown} from '@hconnect/uikit'
import {Box} from '@mui/material'
import React from 'react'
import {Controller} from 'react-hook-form'

import {Option} from '../../../common/AutoSelectDropdown'
import {useTranslation} from '../../../hooks/useTranslation'
import {useWidgetUserCreationStyles} from '../WidgetUserCreation.styles'

import {WidgetInputsProps} from './WidgetInputs.types'

type WidgetMarketInputProps = WidgetInputsProps & {
  marketSelectValues: Option[]
  isLoadingMarkets: boolean
}
export const WidgetMarketInput = ({
  formMethods,
  marketSelectValues,
  isLoadingMarkets
}: WidgetMarketInputProps) => {
  const {t} = useTranslation()
  const {classes} = useWidgetUserCreationStyles()

  return (
    <Controller
      name="market"
      control={formMethods.control}
      render={({field}) => (
        <SelectDropdown
          {...field}
          showSearch={false}
          disabled={!formMethods.watch().country}
          data-test-id="widget-market-dropdown"
          label={t('widgetUserCreation.form.market')}
          className={classes.selectDropdown}
          errorRender={() => <ErrorPaper variant="primaryDark" />}
          selectedProps={{style: {fontWeight: 400}}}
          showError={false}
          loading={isLoadingMarkets}
          options={marketSelectValues}
          renderItem={(item: Item) => (
            <Box style={{display: 'flex', flexDirection: 'column'}}>
              <Box>{item.label}</Box>
              <Box>{item.value}</Box>
            </Box>
          )}
          stringifyItem={(item: Item) => item.value}
          renderChosenItem={(item: Item) => item.label}
          selectedItem={{
            label: marketSelectValues?.find((option) => option.value === field.value)?.label || '',
            value: marketSelectValues?.find((option) => option.value === field.value)?.value || ' '
          }}
          popoverStyle={{left: 0}}
          onChange={(item) => {
            field.onChange(item.value)
          }}
        />
      )}
    />
  )
}
